import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { useBoolean } from '../utils/hooks/useBoolean.js';

function usePopover() {
  var opened = useBoolean(false);
  var open = opened.value;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchor = _React$useState2[0],
    setAnchor = _React$useState2[1];
  var boundaryRef = React.useRef(null);
  var focusRef = React.useCallback(function (node) {
    var scrollingElement = document.scrollingElement || document.documentElement;
    var scrollTop = scrollingElement.scrollTop,
      scrollLeft = scrollingElement.scrollLeft;
    //istanbul ignore else - not relevant case
    if (node && open) {
      node.focus({
        preventScroll: true
      });

      //istanbul ignore if - this hack is for browsers not supporting preventScroll
      if (scrollTop) scrollingElement.scrollTop = scrollTop;
      //istanbul ignore if - this hack is for browsers not supporting preventScroll
      if (scrollLeft) scrollingElement.scrollLeft = scrollLeft;
    } else if (!node && anchor) {
      anchor.focus({
        preventScroll: true
      });

      //istanbul ignore if - this hack is for browsers not supporting preventScroll
      if (scrollTop) scrollingElement.scrollTop = scrollTop;
      //istanbul ignore if - this hack is for browsers not supporting preventScroll
      if (scrollLeft) scrollingElement.scrollLeft = scrollLeft;
    }
  }, [open, anchor]);
  var handleOpen = React.useCallback(function (e) {
    opened.setTrue();
    setAnchor(e.currentTarget);
  }, [opened]);
  var handleClose = opened.setFalse;
  return {
    open: open,
    anchor: anchor,
    setAnchor: setAnchor,
    handleOpen: handleOpen,
    handleClose: handleClose,
    focusRef: focusRef,
    boundaryRef: boundaryRef
  };
}

export { usePopover };
